import { render, staticRenderFns } from "./newNav.vue?vue&type=template&id=449f2bf8&scoped=true&"
import script from "./newNav.vue?vue&type=script&lang=js&"
export * from "./newNav.vue?vue&type=script&lang=js&"
import style0 from "./newNav.vue?vue&type=style&index=0&id=449f2bf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449f2bf8",
  null
  
)

export default component.exports